import {
  FormFieldComponent,
  FormFieldComponentProps,
} from "./form_fields/FormFieldComponent";

export const NewSingleFormComponent = (props: {
  props: NewSingleFormComponentProps;
  data: any;
  setData: any;
}) => {
  return (
    <>
      {props.props.formFields.map((field, index) => (
        <FormFieldComponent
          key={index}
          props={field}
          data={props.data}
          setData={props.setData}
        />
      ))}
    </>
  );
};

export type NewSingleFormComponentProps = {
  formFields: FormFieldComponentProps[];
  type: "single_form";
};
